import { Typography } from '@nilohealth/core-ui'

import { NavbarListItem, NavbarListContainer } from './navbar.styles'

import Dashboards from './dashboards/dashboards'

const NavbarList = () => {
  return (
    <NavbarListContainer>
      <NavbarListItem key="home" href="/">
        <Typography type="subtitleXSmall" weight="medium">
          Início
        </Typography>
      </NavbarListItem>

      <Dashboards />
    </NavbarListContainer>
  )
}

export default NavbarList
